// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"438":"a94edea58437ccb0","888":"53555cd2683974b1"}[chunkId] + ".css";
};